import React from 'react';

import { CartPrice } from '@sharedComponents/Prices';
import { getNumberInNegative } from '@utils/math';

import { StyledDescription, StyledTitleText } from './styled';

export const BodyColumn = (text: React.ReactNode) => () => <StyledTitleText>{text}</StyledTitleText>;

export const InfoColumn = (description: string) => () => <StyledDescription>{description}</StyledDescription>;

export const PriceColumn = (isDualPriceLayout: boolean, value: number) => () => (
  <CartPrice isDualPriceLayout={isDualPriceLayout} price={getNumberInNegative(value)} isColumnLayout={true} />
);
